import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CheckItem } from '../CheckItem';
import { audienceItems } from '../../data/salesContent';
export function AudienceSection() {
  return;
}